// import EventAnalytics from './EventAnalytics/analytics';
import YouVisitAnalytics from "./YouVisitAnalytics/analytics";

export default { YouVisitAnalytics };
